/**
 * This component renders the sidebar for a club page
 * @param {object} data - All processed data about the club
 * @param {object} gradientStyle Club gradient style
 * WARNING - Currently using some dummy data
 */
import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import ProfileImageContainer from "../core/ProfileImageContainer";
import { Link } from "react-router-dom";
import Loading from "../core/Loading";

const SidebarContent = ({ division }) => {


  const processDivisionData = (jsonData) => {

    return jsonData;
  };

  const { isLoading, error, data } = useQuery({
    staleTime: 3600000, // Cache for 1 hour
    queryKey: ["division", division.id],
    queryFn: () =>
      fetch(
        `${process.env.REACT_APP_BUIHA_API_URL}/division/${division.id}/sidebar`
      )
        .then((res) => res.json())
        .then((json) => {
          return processDivisionData(json);
        }),
  });

  if (isLoading) return <Loading />;

  if (error) return "An error has occurred: " + error.message;

  return (
    <>
      <div className="sidebar flex flex-col items-center justify-start w-auto xs:m-1 xs:mx-4 pt-4 xs:mb-4 xl:mr-8 xl:px-0 px-2 xxs:px-4 mb-8">
        <div className="max-w-[800px] w-full">
          <div className="flex flex-col mb-1 justify-center items-center">
            <h2 className="text-xl font-normal text-center">Division Info</h2>

            <div className="w-full h-2 mt-2 my-2 bg-gradient-to-r from-blue-600 via-purple-600 to-red-600">
              <p className="hidden">Gradient line</p>
            </div>

            <>
              <div className="flex flex-col justify-start xl:items-start items-center w-full mt-1 mb-2">
                <div className="flex flex-row justify-between items-center w-full">
                  <p className="text-left lg:b-2 pr-2 font-normal pb-0.5">
                    Season:
                  </p>
                  <p className="text-right lg:b-2 font-light">{division.season}</p>
                </div>
                <div className="flex flex-row justify-between items-center w-full">
                  <p className="text-left lg:b-2 pr-2 font-normal pb-0.5">
                    Conference:
                  </p>
                  <p className="text-right lg:b-2 font-light">{division.conference}</p>
                </div>
                <div className="flex flex-row justify-between items-center w-full">
                  <p className="text-left lg:b-2 pr-2 font-normal pb-0.5">
                    Type:
                  </p>
                  <p className="text-right lg:b-2 font-light">
                    {division.is_cup
                        ? "Cup Competition"
                        : division.name.includes("Nationals")
                            ? "National Championship"
                            : "Other"}
                  </p>
                </div>

                <div className="flex flex-row justify-between items-center w-full">
                  <p className="text-left lg:b-2 pr-2 font-normal pb-0.5">
                    Status:
                  </p>
                  <p className="text-right lg:b-2 font-light">{division.season_offset === 0 ? "Active" : "Complete"}</p>
                </div>
              </div>
            </>

            <div className="w-full h-2 mt-2 bg-gradient-to-r from-blue-600 via-purple-600 to-red-600">
              <p className="hidden">Gradient line</p>
            </div>

            {data.stats.length > 0 ? (
              <div>
                <h2 className="text-xl font-normal text-center mt-4">Division Stat Leaders</h2>

                {/* Stat leaders */}
                <div className="flex flex-col justify-center items-center mt-4">
                  <div className="w-[340px] flex flex-col justify-start items-center ">
                    {/* Points leader */}
                    {data.stats.map((stat) => (
                        <Link
                            key={stat.player} // It's good practice to add a unique key for each iteration
                            to={`/player/${stat.player}`} // Use `stat.player` instead of `data.stats[0].player`
                            className="w-full"
                        >
                          <div className="group flex flex-row justify-start items-center w-full mb-2">
                            <div
                                className="h-14 w-14 mr-2 rounded-full bg-white dark:bg-dark-2 flex flex-col justify-center items-center">
                              <ProfileImageContainer
                                  player={stat.player} // Pass the current stat's player
                                  club={stat.club}
                                  backup={stat.club_short.toLowerCase()}
                                  alt="Player image"
                                  extraClasses={"rounded-full"}
                              />
                            </div>
                            <div className="flex flex-col justify-start items-start">
                            <p className="text-xsm text-left leading-tight whitespace-nowrap dark:group-hover:text-dark-5 group-hover:text-buiha-red transition-colors duration-200">
                                {stat.name} (
                                {stat.club_short.substring(0, 3).toUpperCase()})
                              </p>
                              <p className="font-light text-xxs">{stat.title}</p>
                            
                              <p className="text-darken font-light text-xxs">{stat.label}</p>
                            </div>
                          </div>
                        </Link>
                    ))}
                    {/**
                     {data.stats.slice(3, 8).map((stat) => (
                     <div className="flex flex-row justify-between items-center w-full">
                     <p className="text-left lg:b-2 pr-2 font-normal pb-0.5">
                     {stat.name}
                     </p>
                     <p className="text-right lg:b-2 font-light">
                     {stat.total_points} PTS
                     </p>
                     </div>
                     ))}
                     */}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarContent;
